import type { FC } from 'react';
import PaymentDetails from '../../../Bookings/BookingDetails/Payment/PaymentDetails';
import { PackageType } from '../../types';
import { Payment, Transaction } from '../../../Customers/types/types';
import { useAddPackagePaymentTransactionMutation } from '../../graphql/addPackagePaymentTransaction.generated';
import { useDeletePackagePaymentTransactionMutation } from '../../graphql/deletePackagePaymentTransaction.generated';
import { useUpdatePackagePaymentNoteMutation } from '../../graphql/updatePackagePaymentNote.generated';

type Props = {
  payment: PackageType['customerPayment'];
  title?: string;
};

const PackagePayment: FC<Props> = ({ payment, title = 'Payments' }) => {
  const [addPackagePaymentTransaction] = useAddPackagePaymentTransactionMutation();
  const [deletePackagePaymentTransaction] = useDeletePackagePaymentTransactionMutation();
  const [updatePackagePaymentNote] = useUpdatePackagePaymentNoteMutation();

  const handleAddPayment = async (transaction: Omit<Transaction, 'type'>) => {
    await addPackagePaymentTransaction({
      variables: { paymentId: payment?.id || '', transaction },
      refetchQueries: ['getPackage'],
      awaitRefetchQueries: true
    });
  };

  const handleDeletePackagePayment = async (transactionId: string) => {
    await deletePackagePaymentTransaction({
      variables: { paymentId: payment?.id || '', transactionId },
      refetchQueries: ['getPackage'],
      awaitRefetchQueries: true
    });
  };

  const handleUpdateNote = async (notes: string) => {
    await updatePackagePaymentNote({
      variables: { paymentId: payment?.id || '', notes },
      refetchQueries: ['getPackage'],
      awaitRefetchQueries: true
    });
  };

  return (
    <div>
      <PaymentDetails
        payment={payment as Payment}
        title={title}
        handleAddNote={handleUpdateNote}
        handleAddPayment={handleAddPayment}
        handleDeletePayment={handleDeletePackagePayment}
        shouldShowAction={(transaction) => !transaction.code}
      />
    </div>
  );
};

export default PackagePayment;
